import { FC, ReactNode } from 'react';
import { VStack } from '@chakra-ui/react';

import SunshineIcon from 'components/_core/SunshineIcon';
import Text from 'components/_core/Text';

interface CellProps {
  withBorderBottom: boolean;
  asset?: ReactNode;
  label?: string;
  check?: boolean;
}

const Cell: FC<CellProps> = ({ asset, check, label, withBorderBottom }) => (
  <VStack
    alignItems="center"
    borderBottom={withBorderBottom ? '1px solid' : 'none'}
    borderColor="grey.2"
    justifyContent="center"
    marginX="space-16"
    paddingY="space-24"
    position="relative"
  >
    {asset ? asset : null}

    {check !== undefined ? (
      <SunshineIcon
        color={check ? 'grey.800' : 'grey.600'}
        name={check ? 'tick' : 'cross'}
      />
    ) : null}

    {label ? (
      <Text textAlign="center" variant="primary">
        {label}
      </Text>
    ) : null}
  </VStack>
);

export default Cell;
